'use client';

import { cn } from '@/lib/utils';

type SkeletonCheckboxProps = {
  className?: string;
  count?: number;
};

export default function SkeletonCheckbox({ className, count = 1 }: SkeletonCheckboxProps) {
  const skeletonItems = Array.from({ length: count }, (_, index) => (
    <div key={`skeleton-checkbox-${index}`} className="flex items-start space-x-3">
      <div className="mt-1 h-4 w-4 rounded border border-border bg-muted animate-pulse" />
      <div className="flex-1 space-y-2">
        <div className="h-4 w-3/4 rounded bg-muted animate-pulse" />
        <div className="h-3 w-1/2 rounded bg-muted animate-pulse" />
      </div>
    </div>
  ));

  return (
    <div className={cn('space-y-4', className)}>
      {skeletonItems}
    </div>
  );
}
